export default __webpack_public_path__ + "static/media/EnterpriseIcon.453a6919.png";